import { useState } from "react";
import { client } from "@/lib/api";
import { RivetsApiError } from "@rivets/core";
import { BrandLogo } from "@/components/BrandLogo";

const BASE_SEATS = 2;
const BASE_PRICE = 195;
const EXTRA_SEAT_PRICE = 79;

export function BuyPage() {
  const [seats, setSeats] = useState(BASE_SEATS);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const extraSeats = Math.max(0, seats - BASE_SEATS);
  const total = BASE_PRICE + extraSeats * EXTRA_SEAT_PRICE;

  async function handleCheckout() {
    setLoading(true);
    setError(null);
    try {
      const { url } = await client.checkout({ seats });
      window.location.href = url;
    } catch (e) {
      setError(e instanceof RivetsApiError ? e.message : "Could not start checkout.");
      setLoading(false);
    }
  }

  return (
    <div className="auth-shell">
      <div className="auth-card buy-card">
        <BrandLogo className="auth-logo" size={22} />
        <h1 className="auth-title">Buy Rivets</h1>
        <p className="auth-subtitle">Choose the team size that fits today.</p>

        <div className="panel">
          <div className="label">Seats</div>
          <div className="seat-stepper">
            <button
              className="btn btn-sm"
              onClick={() => setSeats((s) => Math.max(BASE_SEATS, s - 1))}
              disabled={seats <= BASE_SEATS}
              aria-label="Remove seat"
            >
              −
            </button>
            <span className="count">{seats}</span>
            <button
              className="btn btn-sm"
              onClick={() => setSeats((s) => Math.min(100, s + 1))}
              disabled={seats >= 100}
              aria-label="Add seat"
            >
              +
            </button>
            <span className="hint" style={{ marginTop: 0 }}>
              {extraSeats > 0 ? `${extraSeats} discounted extra seat${extraSeats === 1 ? "" : "s"}` : "base plan"}
            </span>
          </div>

          <div className="purchase-reassurance">One-time purchase · {BASE_SEATS} seats included · no subscription</div>

          <div className="price-row">
            <span>Base plan · {BASE_SEATS} seats</span>
            <span>${BASE_PRICE}</span>
          </div>
          {extraSeats > 0 && (
            <div className="price-row">
              <span>
                {extraSeats} × extra seat (discounted) · ${EXTRA_SEAT_PRICE}/seat
              </span>
              <span>${extraSeats * EXTRA_SEAT_PRICE}</span>
            </div>
          )}
          <div className="price-row total">
            <span>Total</span>
            <span>${total}</span>
          </div>

          <button className="btn btn-primary btn-block" style={{ marginTop: 14 }} onClick={handleCheckout} disabled={loading}>
            {loading ? "Redirecting…" : "Continue to checkout"}
          </button>
          {error && <div className="error-text">{error}</div>}
        </div>

        <p className="auth-footer">Already purchased? Check your email for a claim link.</p>
      </div>
    </div>
  );
}
